/* ARTEMIS CLO (ajout maison, CUSTOM.txt point 7) : encart des paliers de la fiche.
   Met en avant la ligne du palier atteint par la quantite choisie (1, 2, 3+), et recalcule les prix unitaires
   si la variante change de prix. Les taux viennent du rendu Liquid (data-pct), jamais d'une constante ici. */
(function () {
  function fmt(cents, devise) {
    try { return new Intl.NumberFormat('en-GB', {style: 'currency', currency: devise || 'GBP'}).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function maj(box) {
    var sec = box.closest('.shopify-section') || document;
    var input = sec.querySelector('product-form input[name="quantity"]') || sec.querySelector('input[name="quantity"]');
    var q = Math.max(1, parseInt(input && input.value, 10) || 1);
    var lignes = box.querySelectorAll('.ac-paliers__ligne');
    var actif = null;
    lignes.forEach(function (l) { if (q >= parseInt(l.dataset.q, 10)) actif = l; });
    lignes.forEach(function (l) { l.classList.toggle('is-actif', l === actif); });
    var c = sec.querySelector('[data-ref="add-to-cart-button-container"][data-price]');
    var prix = c ? parseInt(c.dataset.price, 10) : NaN;
    if (!isNaN(prix) && String(prix) !== box.dataset.prix) {
      box.dataset.prix = String(prix);
      box.querySelectorAll('.ac-paliers__prix').forEach(function (p) {
        var pct = parseInt(p.dataset.pct, 10) || 0;
        var u = Math.floor((prix * (100 - pct) + 50) / 100);
        p.firstChild.nodeValue = fmt(u, box.dataset.devise) + (pct ? ' ' : '');
      });
    }
  }
  function tout() { document.querySelectorAll('[data-ac-paliers]').forEach(maj); }
  function plusTard() { setTimeout(tout, 0); setTimeout(tout, 300); }
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') tout(); });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') tout(); });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('quantity-selector')) plusTard(); });
  document.addEventListener('variant:updated', plusTard);
  document.addEventListener('form:updated', plusTard);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
})();
